var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOlympicFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 900 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h900v600H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 17.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 232.3,
    cy: 253.5,
    r: 91.6,
    stroke: "#0885c2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 253.5,
    r: 91.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 667.7,
    cy: 253.5,
    r: 91.6,
    stroke: "#ed334e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.2,
    cy: 346.5,
    r: 91.6,
    stroke: "#fbb132"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.8,
    cy: 346.5,
    r: 91.6,
    stroke: "#00a651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.6 198.5a91.6 91.6 0 0 1 0 109.9",
    stroke: "#0885c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.3 198.5a91.6 91.6 0 0 1 0 109.9M450 345a91.6 91.6 0 0 1-55-18.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.7 345a91.6 91.6 0 0 1-55-18.3",
    stroke: "#ed334e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlympicFlag);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDkwMCA2MDAiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoOTAwdjYwMEgweiIvPjxnIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIxNy43Ij48Y2lyY2xlIGN4PSIyMzIuMyIgY3k9IjI1My41IiByPSI5MS42IiBzdHJva2U9IiMwODg1YzIiLz48Y2lyY2xlIGN4PSI0NTAiIGN5PSIyNTMuNSIgcj0iOTEuNiIvPjxjaXJjbGUgY3g9IjY2Ny43IiBjeT0iMjUzLjUiIHI9IjkxLjYiIHN0cm9rZT0iI2VkMzM0ZSIvPjxjaXJjbGUgY3g9IjM0MS4yIiBjeT0iMzQ2LjUiIHI9IjkxLjYiIHN0cm9rZT0iI2ZiYjEzMiIvPjxjaXJjbGUgY3g9IjU1OC44IiBjeT0iMzQ2LjUiIHI9IjkxLjYiIHN0cm9rZT0iIzAwYTY1MSIvPjxwYXRoIGQ9Ik0zMDUuNiAxOTguNWE5MS42IDkxLjYgMCAwIDEgMCAxMDkuOSIgc3Ryb2tlPSIjMDg4NWMyIi8+PHBhdGggZD0iTTUyMy4zIDE5OC41YTkxLjYgOTEuNiAwIDAgMSAwIDEwOS45TTQ1MCAzNDVhOTEuNiA5MS42IDAgMCAxLTU1LTE4LjMiLz48cGF0aCBkPSJNNjY3LjcgMzQ1YTkxLjYgOTEuNiAwIDAgMS01NS0xOC4zIiBzdHJva2U9IiNlZDMzNGUiLz48L2c+PC9zdmc+";
export { ForwardRef as ReactComponent };